<template>
    <div class="App_Main_Content" :style="$route.path.indexOf('admin')>-1?{overflow:'auto !important'}:''">
        <component :is="layout">

        </component>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        props: {
            layout: {
                type: String,
                default: ''
            }
        },
        created() {
        },
        mounted(){
            // 初始化
            this.setRem();
            // 改变窗口大小时重新设置 rem
            let that = this
            window.onresize = function() {
                that.setRem();
            };
        },
        methods: {
            setRem() {
                const scale = document.documentElement.clientWidth / 3840;
                // 设置 CSS 变量，供浮层使用
                document.body.style.setProperty('--screen-scale', `scale(${scale})`)
            }
        }
    }
</script>

<style lang="less" scoped>
    .App_Main_Content{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
    }
</style>